module.exports = __webpack_public_path__ + "img/EXTERIOR-SWIFT-SPORT-3.f125b2e1.jpg";